import dynamic from 'next/dynamic';

import { IconProps } from '@crehana/icons/dist/types';

const icons = {
  DataUsage: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/DataUsage'),
  ),
  DataUsage2: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/DataUsage2'),
  ),
  Dashboard2: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Dashboard2'),
  ),
  Cloud: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Cloud'),
  ),
  DateAndTime: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/DateAndTime'),
  ),
  Brain: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Brain'),
  ),
  TrendingUp: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/TrendingUp'),
  ),
  Idea: dynamic<IconProps>(() => import('@crehana/icons/dist/pictograms/Idea')),
  ShoppingBasket: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/ShoppingBasket'),
  ),
  ShoppingTopic: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/ShoppingTopic'),
  ),
  WebDesign: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/WebDesign'),
  ),
  Settings: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Settings'),
  ),
  FindUser: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/FindUser'),
  ),
  Rocket: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Rocket'),
  ),
  Pencil: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Pencil'),
  ),
  LaptopPremium: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/LaptopPremium'),
  ),
  Announcement: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Announcement'),
  ),
  ELearning: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/ELearning'),
  ),
  Smartphone: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Smartphone'),
  ),
  Workplace: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Workplace'),
  ),
  PasswordEnter: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/PasswordEnter'),
  ),
  CubeModel: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/CubeModel'),
  ),
  GraphicTablet: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/GraphicTablet'),
  ),
  EconomicImprovement: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/EconomicImprovement'),
  ),
  OnlineShopping: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/OnlineShopping'),
  ),
  Comments: dynamic<IconProps>(
    () => import('@crehana/icons/dist/pictograms/Comments'),
  ),
};
export const getIconComponent = (name: string) => {
  const icon = icons[name as keyof typeof icons];
  if (icon) {
    return icon;
  }
  return undefined;
};
